import React, {PropTypes} from 'react'
import {Card, CardHeader, CardText} from 'material-ui/Card'
import {List, ListItem} from 'material-ui/List'
import {blue500, red500, grey500} from 'material-ui/styles/colors'

import Opacity from 'material-ui/svg-icons/action/opacity'
import FormatColorReset from 'material-ui/svg-icons/editor/format-color-reset'

import AssignmentReturned from 'material-ui/svg-icons/action/assignment-returned'
import AssignmentTurnedIn from 'material-ui/svg-icons/action/assignment-turned-in'

import Cancel from 'material-ui/svg-icons/navigation/cancel'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import SwapVerticalCircle from 'material-ui/svg-icons/action/swap-vertical-circle'

const LOWER_FLOAT_LEVEL_SWITCH_ROLE = 1
const UPPER_FLOAT_LEVEL_SWITCH_ROLE = 2
const BOMB_CONTACTOR_ROLE = 16
const BOMB_SELECTOR_ROLE = 13

const getSubtitle = (lowerFloatLevelSwitch, upperFloatLevelSwitch) => {
  const stateLowerFloatLevelSwitch = lowerFloatLevelSwitch && lowerFloatLevelSwitch.updates.length > 0 ? lowerFloatLevelSwitch.updates[0].data === 1 : true
  const stateUpperFloatLevelSwitch = upperFloatLevelSwitch && upperFloatLevelSwitch.updates.length > 0 ? upperFloatLevelSwitch.updates[0].data === 1 : false

  if (stateUpperFloatLevelSwitch && !stateLowerFloatLevelSwitch) {
    return 'Anomalia encontrada'
  } else if (!stateUpperFloatLevelSwitch && !stateLowerFloatLevelSwitch) {
    return 'Nível muito baixo'
  }

  return 'Nível normal'
}

const BombItem = ({id, description, bombContactor, bombSelectors}) => {
  if (bombContactor) {
    if (bombContactor.updates.length > 0 && bombContactor.updates[0].data === 1) {
      return (
        <ListItem
          primaryText={description}
          secondaryText="Ativada"
          rightIcon={<SwapVerticalCircle color={blue500} />} />
      )
    }
  }
  const selectorActive = bombSelectors.find(selector => selector.updates.length > 0 && selector.updates[0].data === 1)
  if (selectorActive) {
    if (selectorActive.role_identifier !== id) {
      return (
        <ListItem
          primaryText={description}
          secondaryText="Indisponível"
          rightIcon={<Cancel color={red500} />} />
      )
    }
  }
  return (
    <ListItem
      primaryText={description}
      secondaryText="Disponível"
      rightIcon={<CheckCircle color={grey500} />} />
  )
}

const SupplyItem = ({upperFloatLevelSwitch}) => {
  if (!upperFloatLevelSwitch) {
    return null
  }

  const state = upperFloatLevelSwitch && upperFloatLevelSwitch.updates.length > 0 ? upperFloatLevelSwitch.updates[0].data === 1 : false
  return (
    <ListItem
      primaryText="Nível superior"
      secondaryText={state ? 'Normal' : 'Não detectado'}
      rightIcon={state ? <AssignmentTurnedIn color={blue500} /> : <AssignmentReturned color={grey500} />} />
  )
}

const LevelItem = ({lowerFloatLevelSwitch, upperFloatLevelSwitch}) => {
  const stateLowerFloatLevelSwitch = lowerFloatLevelSwitch && lowerFloatLevelSwitch.updates.length > 0 ? lowerFloatLevelSwitch.updates[0].data === 1 : true
  const stateUpperFloatLevelSwitch = upperFloatLevelSwitch && upperFloatLevelSwitch.updates.length > 0 ? upperFloatLevelSwitch.updates[0].data === 1 : false

  let secondaryText = 'Normal'
  let color = blue500

  if (stateUpperFloatLevelSwitch && !stateLowerFloatLevelSwitch) {
    secondaryText = 'Defeito'
    color = red500
  } else if (!stateUpperFloatLevelSwitch && !stateLowerFloatLevelSwitch) {
    secondaryText = 'Não detectado'
    color = grey500
  }

  return (
    <ListItem
      primaryText={upperFloatLevelSwitch ? 'Nível inferior' : 'Nível'}
      secondaryText={secondaryText}
      rightIcon={color === blue500 ? <Opacity color={color} /> : <FormatColorReset color={color} />} />
  )
}

const Cistern = ({id, description, bombs, informations, style}) => {
  const bomb = bombs && bombs.length > 0 ? bombs[0] : {}
  let lowerFloatLevelSwitch = null
  let upperFloatLevelSwitch = null
  let bombContactor = null
  let bombSelectors = []

  informations.forEach(information => {
    switch (information.role) {
      case LOWER_FLOAT_LEVEL_SWITCH_ROLE:
        if (information.role_identifier === id) {
          lowerFloatLevelSwitch = information
        } else if (information.role_identifier === null && lowerFloatLevelSwitch === null) {
          lowerFloatLevelSwitch = information
        }
        break
      case UPPER_FLOAT_LEVEL_SWITCH_ROLE:
        if (information.role_identifier === id) {
          upperFloatLevelSwitch = information
        } else if (information.role_identifier === null && upperFloatLevelSwitch === null) {
          upperFloatLevelSwitch = information
        }
        break
      case BOMB_CONTACTOR_ROLE:
        if (information.role_identifier === bomb.id) {
          bombContactor = information
        }
        break
      case BOMB_SELECTOR_ROLE:
        bombSelectors.push(information)
        break
      default:
        break
    }
  })

  return (
    <Card style={{...style}}>
      <CardHeader
        title={description || 'Cisterna'}
        subtitle={getSubtitle(lowerFloatLevelSwitch, upperFloatLevelSwitch)}
        textStyle={{ padding: 0 }}
        style={{ paddingBottom: 0 }} />
      <CardText>
        <List>
          <LevelItem
            lowerFloatLevelSwitch={lowerFloatLevelSwitch}
            upperFloatLevelSwitch={upperFloatLevelSwitch} />
          <SupplyItem
            upperFloatLevelSwitch={upperFloatLevelSwitch} />
          <BombItem
            {...bomb}
            bombContactor={bombContactor}
            bombSelectors={bombSelectors} />
        </List>
      </CardText>
    </Card>
  )
}

Cistern.propTypes = {
  id: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  bombs: PropTypes.array.isRequired,
  informations: PropTypes.array.isRequired
}

export default Cistern



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/Cistern.js
 **/